export default __webpack_public_path__ + "./images/litresSubscribe.fcb1b00c.svg";